<template>
	<div>
		<div class="flex" style="margin-bottom: 10px;"><el-button type="primary" @click="addManager(false)">添加管理员</el-button></div>
		<el-table
			:data="manageList"
			style="width: 100%;margin-bottom: 20px;"
			row-key="id"
			border
			:stripe="true"
			:default-sort="{ prop: 'ctime', order: 'ascending' }"
			@sort-change="sortChange"
		>
			<el-table-column prop="id" label="管理者ID" width="80"></el-table-column>
			<el-table-column prop="name_text" label="管理员名称"></el-table-column>
			<el-table-column prop="group_name" label="所属管理组"></el-table-column>
			<el-table-column prop="ctime" label="添加时间" sortable></el-table-column>
			<el-table-column label="操作" width="240">
				<template slot-scope="scope">
					<el-button type="primary" size="small" @click="addManager(scope.row)">修改</el-button>
					<el-button type="warning" size="small" @click="resetPassword(scope.row)">重置密码</el-button>
					<el-button type="danger" size="small" @click="deleteManager(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="thispage"
				:page-sizes="pageSizes"
				:page-size="pagesize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			></el-pagination>
		</div>
		<el-dialog title="添加/修改管理员" :visible.sync="addDialogShow" width="70%" v-loading="loading" :close-on-click-modal="false">
			<div style="text-align: left;min-height: 50vh;max-height: 80vh;">
				<el-row>
					<el-col :span="4"><span style="line-height: 40px;">管理员名称</span></el-col>
					<el-col :span="12"><el-input v-model="addManagerInfo.name_text" placeholder="请输入管理员名称"></el-input></el-col>
				</el-row>
				<template v-if="!addManagerInfo.id">
					<el-row>
						<el-col :span="4"><span style="line-height: 40px;">管理员账号</span></el-col>
						<el-col :span="12"><el-input v-model="addManagerInfo.name" placeholder="请输入管理员账号"></el-input></el-col>
					</el-row>
					<el-row>
						<el-col :span="4"><span style="line-height: 40px;">管理员密码</span></el-col>
						<el-col :span="12"><el-input v-model="addManagerInfo.password" placeholder="请输入管理员密码"></el-input></el-col>
					</el-row>
				</template>
				<el-row>
					<el-col :span="4"><span style="line-height: 40px;">管理员组</span></el-col>
					<el-col :span="12">
						<el-cascader
							v-model="addManagerInfo.group_id"
							:options="groupList"
							@change="groupChange"
							:props="{ label: 'name', value: 'id' }"
						></el-cascader>
					</el-col>
				</el-row>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="addDialogShow = false">取 消</el-button>
				<el-button type="primary" @click="addSubmit()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
	name: '',
	data() {
		return {
			manageList: [],
			groupList: [],
			defaultProps: {
				children: 'children',
				label: 'name'
			},
			currentScope: '',
			loading: false,
			addDialogShow: false,
			addManagerInfo: {},
			thispage: 1,
			total: 0,
			pagesize: 10, //每页显示条数
			pageSizes: [10, 20, 30] ,//每页显示个数选择器
			sort_param:'',//排序字段
			sort_type:''//排序方式ascending = asc;descending = desc,'' = asc;
		};
	},
	mounted() {
		this.getManagerList();
	},
	methods: {
		...mapActions({
			exit: 'auth/logout'
		}),
		getManagerList() {
			this.$axios({
				url: this.HOST + '/admin.setting/manageList',
				method: 'post',
				data: {
					thispage: this.thispage,
					pagesize: this.pagesize,
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					sort_param:this.sort_param,
					sort_type:this.sort_type
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.total = res.data.total;
						this.manageList = res.data.data;
						if (this.thispage == 1) {
							this.groupList = res.data.groupList;
						}
					}
				})
				.catch(error => {
					console.log(error);
				});
		},
		sortChange({ column, prop, order }) {
			console.log(column, prop, order);
			this.sort_param = prop;
			this.sort_type = order == 'descending'?'desc':'asc';
			this.getManagerList();
		},
		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
			this.pagesize = val;
			this.getManagerList();
		},
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.thispage = val;
			this.getManagerList();
		},
		groupChange(e) {
			let i = e.length;
			this.addManagerInfo.group_id = e[i - 1];
			console.log(e[i - 1]);
		},
		getCheckedNodes(refName) {
			this.$confirm('确认修改当前管理员权限信息吗？')
				.then(() => {
					this.loading = true;
					let arr = this.$refs[refName].getCheckedNodes();
					let newArr = [];
					for (let i in arr) {
						if (!arr[i].children) {
							newArr.push(arr[i].id);
						}
					}
					this.currentScope[refName + '_list'] = newArr;
					this.$axios({
						url: this.HOST + '/admin.setting/changeManageGroup',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							id: this.currentScope.id,
							auth_list: this.currentScope.auth_list,
							menu_list: this.currentScope.menu_list
						}
					})
						.then(res => {
							this.loading = false;
							if (res.data.status == 1) {
								this.$message.success(res.data.msg);
								this[refName + 'TreeShow'] = false;
							} else {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							}
						})
						.catch(err => {
							this.loading = false;
						});
				})
				.catch(() => {
					console.log('手动放弃修改');
				});
		},
		addManager(scope = false) {
			if (!scope) {
				this.addManagerInfo = {
					name: '',
					group_id: '',
					name_text:'',
					password:''
				};
			} else {
				this.addManagerInfo = JSON.parse(JSON.stringify(scope));
			}
			console.log(this.addManagerInfo);
			this.addDialogShow = true;
		},
		resetPassword(scope){
			this.$confirm('确认要重置'+scope.name_text+'的登录密码？')
				.then(() => {
					this.loading = true;
					this.$axios({
						url: this.HOST + '/admin.setting/resetPassword',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							manager_id: scope.id
						}
					})
						.then(res => {
							this.loading = false;
							if (res.data.status == 1) {
								this.$alert('新密码为：'+res.data.newPassword,res.data.msg);
							} else {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							}
						})
						.catch(err => {
							this.loading = false;
						});
				})
				.catch(() => {
					console.log('手动放弃修改');
				});
		},
		addSubmit() {
			this.$confirm('确认信息无误并提交？')
				.then(() => {
					this.loading = true;
					console.log(this.addManagerInfo);
					this.$axios({
						url: this.HOST + '/admin.setting/addManager',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							managerInfo: this.addManagerInfo
						}
					})
						.then(res => {
							this.loading = false;
							if (res.data.status == 1) {
								this.$message.success(res.data.msg);
								this.addDialogShow = false;
								this.getManagerList();
							} else {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							}
						})
						.catch(err => {
							this.loading = false;
						});
				})
				.catch(() => {
					console.log('手动放弃修改');
				});
		},
		deleteManager(scope){
			this.$confirm('确认要删除管理员'+scope.name_text+'？')
				.then(() => {
					this.loading = true;
					this.$axios({
						url: this.HOST + '/admin.setting/deleteManager',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							id: scope.id
						}
					})
						.then(res => {
							this.loading = false;
							if (res.data.status == 1) {
								this.$message.success(res.data.msg);
								this.getManagerList();
							} else {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							}
						})
						.catch(err => {
							this.loading = false;
						});
				})
				.catch(() => {
					console.log('手动放弃修改');
				});
		}
	}
};
</script>
<style>
.el-tree-node.is-expanded > .el-tree-node__children {
	display: flex;
	flex-flow: row wrap;
}
.el-tree::-webkit-scrollbar {
	display: none; /* Chrome Safari */
}
</style>
